export default __webpack_public_path__ + "static/media/banner.c06a53bd.png";